import UserDropdown from "../UserDropdown";
function AdminNavBar(props) {
  return (
    <>
      {/* Navbar */}
      <nav className="top-0 left-0 w-full z-10 flex items-center bg-gray-200 p-4">
        <div className="w-full mx-auto flex items-center justify-end flex-nowrap md:px-10 px-4">
          {/* User */}
          <ul className="flex flex-row list-none items-center">
            <UserDropdown />
          </ul>
        </div>
      </nav>
      {/* End Navbar */}
    </>
  );
}
export default AdminNavBar;
